// The panel docked beside the page (DashboardLayout `panel`) for the topbar's
// alerts, notifications and release notes. It lives in src/app because it composes feature
// components, like the topbar that opens it.
import AlertPanel from '@/components/AlertNotification/AlertPanel'
import WhatsNewPanel from '@/components/WhatsNew/WhatsNewPanel'
import NotificationPanel from '@/modules/Notification/components/Notification/NotificationPanel'
import { useAppStore } from '@/stores/useAppStore'

const SidePanel = () => {
    const sidePanel = useAppStore((state) => state.sidePanel)
    const closeSidePanel = useAppStore((state) => state.closeSidePanel)

    if (sidePanel === 'alerts') return <AlertPanel onClose={closeSidePanel} />
    if (sidePanel === 'notifications')
        return <NotificationPanel onClose={closeSidePanel} />
    if (sidePanel === 'whats-new')
        return <WhatsNewPanel onClose={closeSidePanel} />
    return null
}

export default SidePanel
